import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';
// import { TableColumn } from '../../shared/components/data-table/data-table.component';

@Component({
  selector: 'app-equipment',
  standalone: false,
  templateUrl: './equipment.component.html',
  styleUrl: './equipment.component.scss'
})
export class EquipmentComponent implements OnInit, OnDestroy {
  title = 'Equipment Table';
  equipments: any[]=[];
  equipmentForm: FormGroup;
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  cols: any[] = [
    { field: 'name', header: 'Equipment Name', filterType: 'text', width: '200px' },
    { field: 'code', header: 'Code', filterType: 'text', width: '300px' },
    // { field: 'status', header: 'Status', filterType: 'text', width: '150px' },
  ];
  selectedequipment: any;
  showDeleteDialog: boolean = false;
  systemSection: any;
  private subscriptions = new Subscription();

  // Reusable Dialog Configuration
  createDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;
  initialData: any = {};
  viewMode: boolean = false;

  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    // this.getSystem();
    this.equipmentForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 &]+$')]],
      description: ['', Validators.required],
      status: [true],
      section: ['', Validators.required]
    });

    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    // Create Dialog Configuration
    this.createDialogConfig = {
      title: 'Add new Equipment',
      width: '80vw',
      formLayout: 'single-column',
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Equipment Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Code',
          type: 'text',
          placeholder: 'Enter Equipment Code',
          maxLength: 15,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          validation: {
            required: true
          }
        },
        {
          key: 'section',
          label: 'Section',
          type: 'select',
          options: [],
          validation: {
            required: true
          }
        }
      ],
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    };

    // Update Dialog Configuration
    this.updateDialogConfig = {
      title: 'Update Equipment',
      width: '80vw',
      formLayout: 'single-column',
      fields: [
        {
          key: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Enter Equipment Name',
          maxLength: 100,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'code',
          label: 'Code',
          type: 'text',
          placeholder: 'Enter Equipment Code',
          maxLength: 15,
          validation: {
            required: true,
            pattern: '^[a-zA-Z0-9 &]+$'
          },
          patternErrorMessage: 'Code must be alphanumeric and can include spaces and \'&\' only.'
        },
        {
          key: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter Description',
          maxLength: 500,
          validation: {
            required: true
          }
        },
        {
          key: 'section',
          label: 'Section',
          type: 'select',
          options: [],
          validation: {
            required: true
          }
        },
        {
          key: 'status',
          label: 'Active',
          type: 'checkbox'
        }
      ],
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/equipment-master/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      let resp = res.data || res.results
      this.totalRecords = res.count || 0
      this.equipments = resp.map((item: any) => ({
        ...item,
        section: item.section?.name,
        sectionName: item.section?.name || '',
        sectionCode: item.section?.code || '',
        status: item.status === 1 ? 'Active' : 'Inactive'
      }));
    });
    this.subscriptions.add(sub);
  }

  addEquipment() {
    this.initialData = {
      name: '',
      code: '',
      description: '',
      section: '',
      status: true
    };
    this.viewMode = false;
    this.showDialog = true;
    this.getProposal();
  }

  // New event handlers for reusable dialog
  onCreateSubmit(formData: any): void {
    let payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      section: formData.section,
      status: 1,
    };

    const sub = this.api.postAPI('/master/equipment-master/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Equipment added successfully',
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.name,
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onUpdateSubmit(formData: any): void {
    let equipmentId = this.selectedequipment.id;
    let payload = {
      name: formData.name,
      code: formData.code,
      description: formData.description,
      section: formData.section,
      status: formData.status ? 1 : 2
    };
    
    const sub = this.api.putAPI(`/master/equipment-master/${equipmentId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Equipment updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'failed',
          summary: 'Failed',
          detail: res.detail
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onDialogCancel(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
  }

  onDialogClose(): void {
    this.showDialog = false;
    this.isUpdatedialog = false;
  }
viewSystem(rowData: any) {
  this.viewMode = true;
  this.updateDialogConfig.title = 'View Equipment';
  this.updateDialogConfig.submitButtonText = 'Close';
  this.updateDialogConfig.showCancelButton = false;
  
  if (rowData && rowData.id) {
    this.selectedequipment = rowData;
    this.isUpdatedialog = true;
    
    const sub = this.api.getAPI('/master/section-master/').subscribe((res: any) => {
      let resp = res.data || res.results;
      if (resp && Array.isArray(resp)) {
        this.systemSection = resp.map((section: any) => ({
          label: section.name,
          value: section.id,
        }));
        
        // Update the section options in the dialog config
        const sectionField = this.updateDialogConfig.fields.find(field => field.key === 'section');
        if (sectionField) {
          sectionField.options = this.systemSection;
        }
        
        const matchedSection = this.systemSection.find(sec => sec.label === rowData.sectionName);
        this.initialData = {
          name: rowData.name || '',
          code: rowData.code || '',
          description: rowData.description || '',
          section: matchedSection ? matchedSection.value : null,
          status: rowData.status === 'Active' ? true : false,
        };
      } else {
        console.error('Invalid response format:', res);
        this.systemSection = [];
      }
    });
    this.subscriptions.add(sub);
  }
}


updateEquipment(equipment: any): void {
  this.viewMode = false;
  this.updateDialogConfig.title = 'Update Equipment';
  this.updateDialogConfig.submitButtonText = 'Submit';
  this.updateDialogConfig.showCancelButton = true;
  
  if (equipment && equipment.id) {
    this.selectedequipment = equipment;

    const sub = this.api.getAPI('/master/section-master/').subscribe((res: any) => {
      let resp = res.data || res.results;
      if (resp && Array.isArray(resp)) {
        this.systemSection = resp.map((section: any) => ({
          label: section.name,
          value: section.id,
        }));
        
        // Update the section options in the dialog config
        const sectionField = this.updateDialogConfig.fields.find(field => field.key === 'section');
        if (sectionField) {
          sectionField.options = this.systemSection;
        }
        
        const matchedSection = this.systemSection.find(sec => sec.label === equipment.sectionName);
        this.initialData = {
          name: equipment.name || '',
          code: equipment.code || '',
          description: equipment.description || '',
          section: matchedSection ? matchedSection.value : null,
          status: equipment.status === 'Active' ? true : false,
        };
        this.isUpdatedialog = true;
      } else {
        console.error('Invalid response format:', res);
        this.systemSection = [];
      }
    });
    this.subscriptions.add(sub);
  } else {
    console.error('Invalid equipment data provided for editing');
  }
}


  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedequipment = equipment
  }
  deleteequipment() {
    let sectionId = this.selectedequipment.id
    const sub = this.api.deleteAPI(`/master/equipment-master/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.showDeleteDialog = false
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Equipment Deleted Successfully',
        });
        this.getSystem()

      },
      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete the proposal. Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }



  getProposal() {
    const sub = this.api.getAPI('/master/section-master/').subscribe((res: any) => {
      let resp = res.data || res.results;
      this.systemSection = resp.map((section: any) => ({
        label: section.name,
        value: section.id
      }));

      // Update the section options in the create dialog config
      const sectionField = this.createDialogConfig.fields.find(field => field.key === 'section');
      if (sectionField) {
        sectionField.options = this.systemSection;
      }
    });
    this.subscriptions.add(sub);
  }

  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/equipment', 'Edit') ||
      this.permissionService.hasPrivilege('/master/equipment', 'Delete') ||
      this.permissionService.hasPrivilege('/master/equipment', 'View');
  }
}

